import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static values = { today: String, type: String }

  connect() {
    if (!this.hasInputTarget) return

    this.originalName = this.inputTarget.name
    this.initializeDatepicker()
  }

  disconnect() {
    if (!this.hasInputTarget || !$(this.inputTarget).data('datepicker')) return

    $(this.inputTarget).datepicker('destroy')
  }

  normalizeSubmission() {
    if (!this.hasInputTarget) return

    const usingToday = this.inputTarget.value === '' || this.inputTarget.value === this.todayValue

    this.inputTarget.value = usingToday ? '' : this.inputTarget.value
    this.inputTarget.disabled = usingToday
    this.inputTarget.name = usingToday ? '' : this.originalName
  }

  reset(event) {
    event.preventDefault()
    this.inputTarget.value = ''
    this.primeTodaySelectionAfterOpen()
    this.submit()
  }

  initializeDatepicker() {
    $(this.inputTarget).datepicker({
      dateFormat: 'dd-mm-yy',
      updateViewDate: true,
      changeMonth: true,
      changeYear: true,
      defaultDate: new Date(),
      minDate: this.minDate,
      maxDate: new Date(),
      beforeShow: () => {
        this.primeTodaySelectionAfterOpen()
      },
      onClose: () => {
        this.clearInputForDefaultToday()
      },
      onSelect: (date) => {
        this.inputTarget.value = date
        this.submit()
      }
    })
  }

  primeTodaySelectionAfterOpen() {
    if (this.inputTarget.value) return

    requestAnimationFrame(() => {
      $(this.inputTarget).datepicker('setDate', new Date())
      this.clearInputForDefaultToday()
    })
  }

  clearInputForDefaultToday() {
    if (this.inputTarget.value === this.todayValue) this.inputTarget.value = ''
  }

  submit() {
    this.normalizeSubmission()

    const loadingScreen = document.getElementById('loading-screen')
    if (loadingScreen) loadingScreen.classList.remove('d-none')

    this.element.submit()
  }

  get minDate() {
    return this.typeValue === 'capesize' ? new Date(2025, 10, 1) : new Date(2023, 7, 5)
  }
}
